import {Component, OnInit} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {QuestionnairePage} from '../../pages/questionnaire/questionnaire';
import {DataProvider} from '../../providers/data';

@Component({
    selector: 'shops-modal',
    templateUrl: 'shops.html'
})

export class ShopsModal implements OnInit {
    public shops: any;
    public curCountry: string;

    constructor(public viewCtrl: ViewController,
                private navParams: NavParams,
                private navCtrl: NavController,
                private dataService: DataProvider) {

        if (this.navParams.get('shops')) {
            this.shops = this.navParams.get('shops');
        }

        this.curCountry = dataService.CURRENT_COUNTRY;
    }

    public ngOnInit(): void {

    }

    public closeModal() {
        this.viewCtrl.dismiss();
    }

    // public backButtonClick() {
    //     this.navCtrl.pop();
    // }

    public restartButtonClick() {
        this.navCtrl.push(QuestionnairePage, { restart: true });
    }
}



// WEBPACK FOOTER //
// ./src/modals/shops/shops.ts